import { Injectable } from '@angular/core';

@Injectable()
export class AttendingTypeService {

  public attendingType: string;

  constructor() { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/attending-type.service.ts